/**
 * FT13-U20: Depreciation preview (FSD 2.2.4.3 Run Depreciation "producing a
 * preview before posting", FIN-F04-V04/V05, AC01-AC02).
 *
 * The INT packet spreads `ASSETS_DEPRECIATION_PREVIEW_ROUTES` and adds the nav
 * item `assets-depreciation-preview`. The route's permission is the preview
 * endpoint's: `assets.depreciation.run` (the same as the run it previews).
 */

import type { RouteRecordRaw } from 'vue-router'

import { ASSETS_PERMISSIONS } from '@/modules/assets/permissions'

export const DEPRECIATION_PREVIEW_PATH = '/assets/depreciation/preview'

export const ASSETS_DEPRECIATION_PREVIEW_ROUTES: RouteRecordRaw[] = [
  {
    path: DEPRECIATION_PREVIEW_PATH,
    name: 'assets-depreciation-preview',
    component: () => import('@/modules/assets/depreciation-preview/DepreciationPreviewView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.depreciationPreview',
      permission: ASSETS_PERMISSIONS.depreciationRun,
    },
  },
]
